module.exports = __webpack_public_path__ + "media/images/maximize-8fbbbe245821919604c3c62ad0a0f4d9.svg";